module.exports = __webpack_public_path__ + "img/en-flag.c7207315.svg";